exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NewRouteDialog-54b30a1f .lessMargin-d3cfa378{margin:0 0 20px 0}.NewRouteDialog-54b30a1f .successMessage-33a414d3{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"NewRouteDialog": "NewRouteDialog-54b30a1f",
	"lessMargin": "lessMargin-d3cfa378",
	"successMessage": "successMessage-33a414d3"
};